<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">
    <i class="bi bi-exclamation-triangle-fill text-warning me-2"></i>
    Planograms span multiple data sources
  </h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>

<div class="modal-body p-3">
  <p class="mb-3">
    Bulk clone copies planograms into a single target store, which belongs to one data source.
    Your selection includes planograms from <strong>{{ groups.length }}</strong> different data sources,
    so it can't be cloned together. Reduce your selection to a single data source — or use a shortcut
    below to keep just one group and continue.
  </p>

  <div class="d-flex flex-column gap-3">
    <div *ngFor="let group of groups" class="card">
      <div class="card-header d-flex align-items-center justify-content-between">
        <span class="fw-semibold">
          <i class="bi bi-hdd-stack me-2"></i>{{ group.dataSourceName }}
          <span class="badge text-bg-secondary ms-2">{{ group.planograms.length }}</span>
        </span>
        <button type="button" class="btn btn-sm btn-outline-primary" (click)="chooseDataSource(group)">
          Clone only these ({{ group.planograms.length }})
        </button>
      </div>
      <ul class="list-group list-group-flush">
        <li *ngFor="let p of group.planograms" class="list-group-item">
          <div class="fw-semibold">{{ p.name }}</div>
          <small class="text-muted">{{ p.storeName }} &middot; {{ p.merchName }}</small>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()">Adjust selection</button>
</div>
